import React from 'react';
import { CloseButton } from 'react-bootstrap';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class ModalWindow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: true ,
            message: props.message
        };
        this.toggleModal = this.toggleModal.bind(this);
    }

    render() {
        const { className, headerClassName } = this.props;
        const { modal } = this.state;
        const backdrop = this.props.backdrop ? this.props.backdrop : true;
        return (
          
             
                 <Modal isOpen={modal} className={className} backdrop={backdrop} size="lgm my-10 mx-20 modal-position-form" >

                            <ModalHeader className={headerClassName} toggle={this.toggleModal}>{this.props.title} <Button className='submit-btn-univer1' onClick={this.toggleModal}><span className='fa fa-times'></span></Button>
                             </ModalHeader>
                            <ModalBody>{this.props.children}</ModalBody>
                           
                </Modal>


                
        );
    }

    toggleModal = () => {
        this.setState((prevState) => ({ modal: !prevState.modal }));
        // this.props.toggleModal();
    }
}

export default ModalWindow;